module.exports = __webpack_public_path__ + "static/media/logo-hf-footer.30fef01b.svg";